export default (function (id) {
  return "id_" + id;
});